import {
  DataVersion,
  IncidentProduct,
  UpdateIncidentFieldsPayload,
} from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateIncidentFields(
  product: IncidentProduct,
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({ product });
  const request = new Request(
    `/v2/orm/location_incidents/fields?${searchParams.toString()}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
    }
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, UpdateIncidentFieldsPayload>(request, {
    onSuccess,
    onError,
    onSuccessInvalidationKeys: [['incidentDetail'], ['locationIncidents']],
  });
}

export default useUpdateIncidentFields;
